const LOAD_DATA_LANDING         = 'LOAD_DATA_LANDING'
const LOAD_DATA_LANDING_SUCCESS = 'LOAD_DATA_LANDING_SUCCESS'
const LOAD_DATA_LANDING_FAILED  = 'LOAD_DATA_LANDING_FAILED'
const UNMOUNT_DATA_LANDING      = 'UNMOUNT_DATA_LANDING'

const initialState = {
  loading: true,
  data: null,
  message: null
}

const landingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_LANDING:
      return {
        ...state,
        loading: true,
        data: null
      }
    case LOAD_DATA_LANDING_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS'
      }
    case LOAD_DATA_LANDING_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED'
      }
    case UNMOUNT_DATA_LANDING:
      return { 
        ...state, 
        loading: true,
        data: null
      }
    default:
      return state
  }
}
export default landingPageReducer